export default __webpack_public_path__ + "static/media/par-build.47db7244.png";